export default {
  barrios: []
}